import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
// import { deleteTransactionSlip, transactionDetail, transactionHistory } from "../../../services/tableOrder.service";
import { useTranslation } from "react-i18next";
import { CONSUMPTION_TAX_RATES, CURRENCY_SYMBOL, PAYMENT_METHOD_TYPES_TRANSACTION, SORT_A, SORT_D, SWAL_SETTINGS } from "../../../../../utils/Constants";
import { capitalizeFirstLetter, formateDate, getDate, getDateInFormat, globalLoader, handleOffcanvasScroll, handleServerValidations, removeSpecialCharacter, showPrice, TrimText, writeMyExcel } from "../../../../../utils/commonfunction";
import { DatePicker, DateRangePicker } from "rsuite";
import moment from "moment";
import RecordNotFound from "../../../shared/recordNotFound";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { ErrorMessage, Field, FieldArray, useFormik } from "formik";
// import { editSalesSlip } from "../../../services/sales-slip.service";
// import { list as TableList } from "../../../services/table.service";
// import { list as StaffList } from "../../../services/staff.service";
import CustomError from "../../../../../utils/customError";
import { useValidationSchemas } from "../../../validator/validation";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../../admin/common/custompagination";
import { transactionList, transactionDetail } from "../../../services/sales.transaction.service";
import { LOADER_TIMEOUT_TIME } from "../../../../../../src/utils/Constants";
import { formatDateTime } from "../../../../../utils/moment-config";

export default function SalesTransactionHistory() {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [List, setList] = useState([]);
  const componentRef = useRef();
  const [transactionData, setTransactionData] = useState([]);
  const [page, setPage] = useState(1);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [itemPerPage] = useState(10);

  const [search, setSearch] = useState({});

  useEffect(() => {
    setLoader(true);
    const formData = new FormData();
    if (Object.keys(search).length) {
      formData.append("search", JSON.stringify(search));
    }
    // Determine the page number
    let page = params.page;
    setPage(page);

    formData.append("page", page);
    formData.append("per_page", itemPerPage);

    transactionList(formData)
      .then((data) => {
        if (data && data.data) {
          setList(data.data.list || []);
          setPage(data.data.page);
          setOffsetPage(data.data.offset);
          setTotalRecords(data.data.total_records || 0);
          if (data.data.list.length == 0 && page > 1) {
            setPage(page - 1);
            navigate(`/restaurant/settings/coupon/${page - 1}`);
          }
        } else {
          setList([]);
          setOffsetPage(0);
          setTotalRecords(0);
        }
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        console.log("error ====> ", error);
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      });
  }, [search, params.page]);

  const getRecordsToExport = () => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      if (Object.keys(search).length) {
        formData.append("search", JSON.stringify(search));
      }
      formData.append("page", 1);
      formData.append("per_page", totalRecords); // Fetch all records for export

      transactionList(formData).then((data) => {
        resolve(data.data.list || []);
      }).catch((error) => {
        console.log("error ====> ", error);
      });
    });
  };

  const lowerButtonRef = useRef(null);

  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [todayDate, setTodayDate] = useState(new Date());

  const handleUpperButtonClick = () => {
    if (lowerButtonRef.current) {
      if (isDatePickerOpen) {
        // Close the DatePicker
        lowerButtonRef.current.close(); // Close the DatePicker programmatically
      } else {
        // Open the DatePicker
        lowerButtonRef.current.open(); // Open the DatePicker programmatically
      }
      setIsDatePickerOpen(!isDatePickerOpen); // Toggle the open/close state
    }
  };

  const handleDateChange = (value) => {
    let obj = { ...search };
    obj.createdAt = { start: value[0], end: value[1] };
    setSearch(obj);
    setIsDatePickerOpen(false); // Close the DatePicker after selection
  };

  const handleToggle = (open) => {
    setIsDatePickerOpen(open);
  };

  const handleDatePickerClose = () => {
    setIsDatePickerOpen(false);
  };

  const getTransactionHistory = () => {
    setLoader(true);
    let data = {
      created: todayDate,
    };
    let page = params.page;
    data.page = page;
    data.per_page = itemPerPage;
  };
  useEffect(() => {
    getTransactionHistory();
  }, [todayDate, params.page, search]);

  const handleExportToExcel = async () => {
    // Headers (match table, exclude Action)
    const headers = ["Date & Time", "Transactions No", "Table No", "Amount", "Payment Method", "Payment Status"];

    // Rows
    const data = await getRecordsToExport();
    const rows = data.map((item) => [
      getDateInFormat(item?.createdAt),
      String(item?.transactionNumber || "").padStart(4, "0"),
      capitalizeFirstLetter(item?.table_number) || "-",
      `${CURRENCY_SYMBOL}${showPrice(item?.grand_total || 0, 2)}`,
      capitalizeFirstLetter(item?.payment_method),
      capitalizeFirstLetter(item?.payment_status),
      // item?.split_count || 0,
      // item?.comment && item.comment.length > 0 ? TrimText(capitalizeFirstLetter(item.comment), 10) : "Success",
    ]);

    // Export
    writeMyExcel([headers, ...rows], "sales_transaction_report.xlsx");
  };

  const getTransactionDetail = (item) => {
    transactionDetail({ _id: item.transactionNumber })
      .then((response) => {
        if (response.success) {
          setTransactionData(response?.data);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
          {/* <button className='btn btn-date'><i className='ti ti-calendar'></i> 14 May 2024 <i
                            className='ti ti-chevron-down'></i></button> */}

          <div style={{ gap: "10px", display: "flex" }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              {/* Upper Button */}
              <button className="btn btn-date" onClick={handleUpperButtonClick}>
                <i className="ti ti-calendar" style={{ color: "#757575" }}></i>{" "}
                <span style={{ color: "#757575" }}>
                  {search && search.createdAt && search.createdAt.start && search.createdAt.end
                    ? `${getDate(search.createdAt.start, "DD/MM/YYYY", false)} - ${getDate(search.createdAt.end, "DD/MM/YYYY", false)}`
                    : t("restaurant.sales.placeholder_date")}
                </span>{" "}
                <i className={`ti ${isDatePickerOpen ? "ti-chevron-up" : "ti-chevron-down"}`} style={{ color: "#757575" }}></i>
              </button>

              {/* Hidden DatePicker */}

              <div style={{ visibility: "hidden", position: "absolute", top: 0, left: 0 }}>
                <DateRangePicker
                  ref={lowerButtonRef}
                  classPrefix="restaurant"
                  placement="bottomStart"
                  container={() => document.body}
                  format={"dd/MM/yyyy"}
                  cleanable={false}
                  editable={false}
                  value={search.createdAt ? [new Date(search.createdAt.start), new Date(search.createdAt.end)] : null}
                  onChange={handleDateChange}
                  onToggle={handleToggle} // Handle open/close state
                  disabledDate={(date) => date > new Date()}
                  onClose={handleDatePickerClose}
                />
              </div>
            </div>

            <button
              className="btn"
              style={{ backgroundColor: "#e42373", color: "white" }}
              onClick={() => {
                let obj = { ...search };
                delete obj.createdAt;
                setSearch(obj);
              }}>
              {t("restaurant.sales.label_Reset_date")}
            </button>
          </div>

          <div className="card-head-group d-flex align-items-center gap-2">
            <button
              className="btn btn-black"
              onClick={() => {
                List?.length && handleExportToExcel();
              }}
              disabled={!List?.length}>
              <i className="ti ti-download"></i> {t("restaurant.sales.label_download")}
            </button>
          
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="table-responsive" ref={componentRef}>
              <table className="table table-printable ">
                <thead>
                  <tr>
                    <th>{t("restaurant.sales.date_time_label")}</th>
                    <th>
                      {t("restaurant.sales.label_slip_number")}
                    </th>
                    <th>
                      {t("restaurant.sales.label_table_no")}
                    </th>
                    <th>
                      {t("restaurant.sales.title_amount")}
                    </th>
                    <th>
                      {t("restaurant.sales.label_choose_payment_method")}
                    </th>

                    <th>{t("restaurant.sales.payment_status_label")}</th>
                    {/* <th>{t("restaurant.sales.split_counts")}</th>
                    <th>{t("restaurant.sales.label_comments")}</th> */}
                    <th>{t("restaurant.sales.label_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {List && List.length
                    ? List.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className="text-nowrap">{getDateInFormat(item?.createdAt)}</span>
                          </td>
                          <td>{String(item?.transactionNumber)?.padStart(4, "0") || ""}</td>
                          <td>{TrimText(capitalizeFirstLetter(item?.table_number), 20) || "-"}</td>
                          <td>{CURRENCY_SYMBOL} {showPrice(item?.grand_total || 0, 2)}</td>
                          <td>{capitalizeFirstLetter(removeSpecialCharacter(item?.payment_method))}</td>
                          <td className="text-capitalize">{item?.payment_status}</td>
                          <td>
                            <button
                              className="btn btn-outline-secondary btn-sm"
                              onClick={() => {
                                getTransactionDetail(item);
                              }}
                              data-bs-toggle="offcanvas"
                              data-bs-target="#view-new-category">
                              <i className="ti ti-eye"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })
                    : ""}
                </tbody>
              </table>
            </div>
            <div className="table-status-info d-flex justify-content-between align-items-center">
              <span>
                {t("restaurant.table_management.label_showing")} {offset + List.length} of {totalRecords} {t("restaurant.table_management.label_entries")}
              </span>
              <nav aria-label="Page navigation example" title={page}>
                {totalRecords && totalRecords > 0 ? <CustomPagination datalength={totalRecords} itemperpage={itemPerPage} currentPage={page} custompath="page" setPage={setPage} pageRoute={[{ name: "settings", path: "/restaurant/sales/sales-transaction-history" }]} /> : ""}
              </nav>
            </div>
          </div>
        </div>
        {/* ) : (
          <RecordNotFound heading="lbl_record_not_found" />
        )} */}
      </div>

      {/* modal for view  */}
      <div className="offcanvas offcanvas-end right-modal-w" id="view-new-category" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
        <div className="offcanvas-header">
          <h3 className="offcanvas-title" id="offcanvasRightLabel">
            {t("restaurant.menu.view_transaction_label")}
          </h3>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close">
            <i className="ti ti-x"></i>
          </button>
        </div>

        <div
          className="offcanvas-body"
          onScroll={(e) => {
            handleOffcanvasScroll(e, "view-new-category");
          }}>
          <div className="view-info">
            <div className="row gap-4">
              <div className="col-md-12">
                <h4>{t("restaurant.sales.date_time_label")}:</h4>
                <p>{formatDateTime(transactionData?.createdAt)}</p>
              </div>
              <div className="col-md-12">
                <h4>{t("restaurant.sales.label_slip_number")}:</h4>
                <p>{transactionData?.transactionNumber}</p>
              </div>
              <div className="col-md-12">
                <h4>{t("restaurant.sales.label_table_no")}:</h4>
                <p>{transactionData?.orderData?.table_number || "-"}</p>
              </div>
              <div className="col-md-12">
                <h4>{t("restaurant.sales.title_amount")}:</h4>
                <p>{CURRENCY_SYMBOL} {showPrice(transactionData?.grand_total || 0, 2)}</p>
              </div>
              <div className="col-md-12">
                <h4>{t("restaurant.sales.payment_status_label")}:</h4>
                <p className="text-capitalize">{transactionData?.payment_status}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}